import { BotDataManagerType, HomeDataManagerType, HomeDataStyle } from '@/const/promotion';
import { IBot, IStory } from '@/interface';
import { fetchBotList, fetchBotListBySpace } from '@/services/bot';
import { fetchStoryList } from '@/services/story';

export const ManageSelectOptions = [
  { label: 'banner', value: HomeDataManagerType.HOMEDATAMANAGERTYPE_BANNER },
  { label: '合集', value: HomeDataManagerType.HOMEDATAMANAGERTYPE_COLLECTION },
  { label: '排行榜', value: HomeDataManagerType.HOMEDATAMANAGERTYPE_RANK },
  { label: '故事', value: HomeDataManagerType.HOMEDATAMANAGERTYPE_RECOMMEND }, // 单个故事
  { label: '多榜单', value: HomeDataManagerType.HOMEDATAMANAGERTYPE_MULTI_COLLECTION }, // 多榜单
  { label: '官方活动', value: HomeDataManagerType.HOMEDATAMANAGERTYPE_OFFICIALGROUP },
];

export const ManageBotSelectOptions = [
  { label: 'banner', value: BotDataManagerType.BOTDATAMANAGERTYPE_BANNER },
  { label: '合集', value: BotDataManagerType.BOTDATAMANAGERTYPE_COLLECTION },
  { label: '手风琴', value: BotDataManagerType.BOTDATAMANAGERTYPE_ACCORDION },
  { label: '最近访问', value: BotDataManagerType.BOTDATAMANAGERTYPE_RECENT_VISIT },
];

export const ManageStyleOptions = [
  { label: '横向滑动', value: HomeDataStyle.HOMEDATASTYLE_HORIZONTAL_SLIDE },
  { label: '竖向滑动', value: HomeDataStyle.HOMEDATASTYLE_VERTICAL_SLIDE },
];

export const formKeys = {
  managerType: 'managerType',
  name: 'name',
  style: 'style',
  story: 'story',
  others: 'others',
  title: 'title',
  stories: 'stories',
  bots: 'bots',
};

export const fetchStoryOptions = async (params?: { spaceId?: string }) => {
  const ret = await fetchStoryList({ size: 9999, ...params, release: true });
  const list: { label: string; value: string; opt: IStory; }[] = [];
  ret.list.forEach((item) => {
    if (item.name && item.id) {
      list.push(({ label: item.name, value: item.id, opt: item }));
    }
  });
  return {
    list,
  };
};

export const fetchBotOptions = async (params?: {
  spaceId?: string,
  name?: string,
  page?: number,
  size?: number,
}) => {
  const { spaceId = '', name = '', page = 1, size = 100 } = params || {};
  let ret;
  if (spaceId) {
    ret = await fetchBotListBySpace({ page, size, spaceId, release: true });
  } else {
    ret = await fetchBotList({ page, size, release: true, name });
  }
  const list: { label: string; value: string; opt: IBot; }[] = [];
  ret.list.forEach((item) => {
    if (item.name && item.id) {
      list.push(({ label: item.name, value: item.id, opt: item }));
    }
  });
  return {
    list,
    hasMore: ret.pageInfo?.total > page * size,
  };
};

export enum ChangeDataType {
  INPUT = 1,
  OUTPUT = 2
}
